import { render } from "./ProjectComponent.vue?vue&type=template&id=6bf0c461&ts=true"
import script from "./ProjectComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectComponent.vue?vue&type=script&lang=ts"

import "./ProjectComponent.vue?vue&type=style&index=0&id=6bf0c461&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__